import { Component } from 'react'
import styled from 'styled-components'

import * as cardUtilities from '@/utilities/client-components/utilities/cardUtilities'

import OpenUrlAction from './OpenUrlAction'
import ShowCardAction from './ShowCardAction'
import SubmitAction from './SubmitAction'

const StyledActions = styled.div`
  display: flex;
  flex-direction: ${(props: any) => (props.orientation === 'horizontal' ? 'row' : 'column')};
  padding: ${(props: any) =>
    cardUtilities.getSpacingFromNumberOrName(props.theme, props.theme.actions.buttonSpacing)}px;
  justify-content: ${(props: any) => {
    switch (props.theme.actions.actionAlignment) {
      case 'center': {
        return 'center'
      }
      case 'right': {
        return 'flex-end'
      }
      case 'stretch': {
        return 'stretch'
      }
      default: {
        return 'flex-start'
      }
    }
  }};
  align-items: ${(props: any) => {
    switch (props.theme.actions.actionAlignment) {
      case 'center': {
        return 'center'
      }
      case 'right': {
        return 'flex-end'
      }
      case 'stretch': {
        return 'stretch'
      }
      default: {
        return 'flex-start'
      }
    }
  }};
`

const MAX_ACTIONS = 4

interface ActionsProps {
  actionHandler(...args: unknown[]): unknown
  actions: {
    type: 'Action.Submit' | 'Action.ShowCard' | 'Action.OpenUrl'
    body?: string
    color?: string
    headers?: object
    data?: object
    method?: 'POST' | 'PUT' | 'DELETE' | 'GET'
    url?: string
    title: string
    card?: {
      items?: unknown[]
    }
  }[]
  disabled?: boolean
  format?: 'normal' | 'outline'
  orientation: string
}

class Actions extends Component<ActionsProps> {
  static displayName = 'Actions'
  static defaultProps = {
    format: 'normal'
  }

  render() {
    const { actions, orientation, format, actionHandler, disabled } = this.props
    return (
      // @ts-expect-error
      <StyledActions orientation={orientation}>
        {actions.slice(0, Math.min(actions.length, MAX_ACTIONS)).map((action: any) => {
          let ActionComponent = null
          switch (action.type) {
            case 'Action.OpenUrl': {
              ActionComponent = OpenUrlAction
              break
            }
            case 'Action.Submit': {
              ActionComponent = SubmitAction
              break
            }
            case 'Action.ShowCard': {
              ActionComponent = ShowCardAction
              break
            }
            case 'Action.Execute': {
              ActionComponent = ShowCardAction
            }
          }

          return (
            // @ts-expect-error
            <ActionComponent
              key={`${action.type}-${action.title}`}
              {...action}
              orientation={orientation}
              format={format}
              actionHandler={actionHandler}
              disabled={disabled}
            />
          )
        })}
      </StyledActions>
    )
  }
}

export default Actions
